import { TCloudinaryImageShape } from '../CloudinaryResponsiveImage/types';
import { AuthorDetailContainer } from '../ArticleHeader/AuthorDetailContainer';
import { TUsersListModalContentListItem } from './types';
import { T2ProfileCardContainer } from '../ProfileCard/T2ProfileCardContainer';
import { UnstyledTooltip } from '../Tooltip/UnstyledTooltip';
import { PROFILE_CARD_HOVER_DELAY } from '../ProfileCard/constants';

type TUsersListProps = {
  usersList: TUsersListModalContentListItem[];
  totalCount: number;
};

const UsersListModalContentListItem = ({
  publicAddress,
  id,
  profileImage,
  name,
  username,
}: TUsersListModalContentListItem & { totalCount: number }) => (
  <li key={id} className="grid grid-cols-8 px-6 gap-4">
    <div className="flex items-center gap-2 justify-between col-span-8">
      <UnstyledTooltip
        direction="right"
        floatingUIHover={PROFILE_CARD_HOVER_DELAY}
        trigger={
          <AuthorDetailContainer
            publicAddress={publicAddress!}
            name={name!}
            username={username!}
            profileImage={profileImage as TCloudinaryImageShape}
          />
        }
      >
        <T2ProfileCardContainer id={id} />
      </UnstyledTooltip>
    </div>
  </li>
);

const UsersListModalContent = ({ usersList, totalCount }: TUsersListProps) => {
  const visibleUsers = usersList.slice(0, 50);
  return (
    <ul className="flex flex-col gap-4 overflow-y-auto max-h-full">
      {visibleUsers.map((user, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <UsersListModalContentListItem key={`${user.id}-${index}`} {...user} totalCount={totalCount} />
      ))}
      {totalCount > 50 && (
        <li className="flex items-center justify-center w-full">+ {totalCount - visibleUsers.length} more</li>
      )}
    </ul>
  );
};

export default UsersListModalContent;
